import { Routes } from '@angular/router';
import { NotAuthenticatedGuard } from './auth/guards/not-authenticated.guard';
import { LoginPageComponent } from './auth/pages/login/login-page.component';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginPageComponent,
    canActivate: [NotAuthenticatedGuard],
  },
  {
    path: '',
    loadChildren: () => import('./core/core.routes').then((m) => m.routes),
  },
];
